module.exports = __webpack_public_path__ + "img/12.a8ec8d05.png";